import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TuneIcon from '@mui/icons-material/Tune';
import { ButtonWithPopup } from '../../common/ButtonWithPopup';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { FancyButton } from '../../common/buttons';
import { FancyAutocomplete } from '../../common/inputs';
import { PopupDivider } from '../../common/Popup';
import {setFilters} from '../../../store/Actions'

export function FilterButton() {
    const dispatch = useDispatch()
    const [popupOpen, setPopupOpen] = useState(true);
    const appHeight = useSelector(state=>state.appHeight)
    const userCategories = useSelector(state=>state.viewingUserCategories);
    const userFriends = useSelector(state=>state.viewingUserFriends);
    const userTrips = useSelector(state=>state.viewingUserTrips);
    const userTags = useSelector(state=>state.viewingUserTags);
    const filteredEvents = useSelector(state=>state.filteredEvents);
    const appWidth = useSelector(state=>state.appWidth);
    const isMobile = appWidth <= 560;
    const popupMaxHeight = Math.max(360, appHeight - (isMobile ? 96 : 190));
    const filterBodyMaxHeight = Math.max(260, popupMaxHeight - (isMobile ? 74 : 82));

    const startDate = useSelector(state=>state.selectedStartDate);
    const endDate = useSelector(state=>state.selectedEndDate);
    const categoryIds = useSelector(state=>state.selectedCategoryIds);
    const friendIds = useSelector(state=>state.selectedFriendIds);
    const tripIds = useSelector(state=>state.selectedTripIds);
    const tagIds = useSelector(state=>state.selectedTagIds);

    let filterCount = 0;
    if(startDate && endDate) filterCount++;
    if(categoryIds.length > 0) filterCount++;
    if(friendIds.length > 0) filterCount++;
    if(tripIds.length > 0) filterCount++;
    if(tagIds.length > 0) filterCount++;

    const selectionRange = {
        startDate,
        endDate,
        key: 'selection',
    }

    if(!userCategories)
        return null;

    const clear = ()=> {
        dispatch(setFilters([], [], [], [], null, null))
    }

    const setFilter = (filter, value)=>{
        if(filter === 'CategoryIds')
            dispatch(setFilters(value, friendIds, tagIds, tripIds, startDate, endDate));
        if(filter === 'FriendIds')
            dispatch(setFilters(categoryIds, value, tagIds, tripIds, startDate, endDate));
        if(filter === 'TagIds')
            dispatch(setFilters(categoryIds, friendIds, value, tripIds, startDate, endDate));
        if(filter === 'TripIds')
            dispatch(setFilters(categoryIds, friendIds, tagIds, value, startDate, endDate));
        if(filter === 'Date')
            dispatch(setFilters(categoryIds, friendIds, tagIds, tripIds, value.selection.startDate, value.selection.endDate));
    }

    const buttonComponent = (
        <>
            <TuneIcon
                className="header-filter-button"
                style={{fontSize:'20px', color: filterCount > 0 ? '#0f0f0f' : '#404040'}}
            />
            {filterCount > 0 && (
                <span
                    aria-label={`${filterCount} filters applied`}
                    style={{
                        position:'absolute',
                        top:0,
                        right:0,
                        transform:'translate(38%, -38%)',
                        minWidth:'18px',
                        height:'18px',
                        padding:'0 5px',
                        borderRadius:'999px',
                        background:'linear-gradient(135deg, #0a0a0a 0%, #262626 100%)',
                        color:'#ffffff',
                        fontSize:'10.5px',
                        fontWeight:700,
                        lineHeight:1,
                        display:'inline-flex',
                        alignItems:'center',
                        justifyContent:'center',
                        fontFeatureSettings:'"tnum"',
                        letterSpacing:'0.1px',
                        boxShadow:'0 1px 3px rgba(0,0,0,0.25)',
                        pointerEvents:'none',
                    }}
                >
                    {filterCount}
                </span>
            )}
        </>
    );

    const popupComponent = (
        <div style={{maxHeight: popupMaxHeight + 'px', display:'flex', flexDirection:'column', overflow:'hidden'}}>
            <div style={{width: isMobile ? '100%' : '610px', maxHeight: filterBodyMaxHeight + 'px', display:'flex', flexDirection:'column', alignItems:'center', overflowY:'auto', overflowX:'hidden'}}>
                <FancyAutocomplete
                    multiple
                    limitTags={2}
                    disablePortal
                    label="Categories"
                    style={{width:'90%', marginTop:'10px'}}
                    options={Object.keys(userCategories)}
                    getOptionLabel={(option) => userCategories[option].name}
                    value={categoryIds}
                    onChange={(newValue) => setFilter('CategoryIds', newValue)}
                />
                <FancyAutocomplete
                    multiple
                    limitTags={2}
                    disablePortal
                    label="Friends"
                    style={{width:'90%', marginTop:'20px'}}
                    options={Object.keys(userFriends)}
                    getOptionLabel={(option) => userFriends[option].name}
                    value={friendIds}
                    onChange={(newValue) => setFilter('FriendIds', newValue)}
                />
                <FancyAutocomplete
                    multiple
                    limitTags={1}
                    disablePortal
                    label="Trips"
                    style={{width:'90%', marginTop:'20px'}}
                    options={Object.keys(userTrips)}
                    getOptionLabel={(option) => userTrips[option].name}
                    value={tripIds}
                    onChange={(newValue) => setFilter('TripIds', newValue)}
                />
                <FancyAutocomplete
                    multiple
                    limitTags={1}
                    disablePortal
                    label="Tags"
                    style={{width:'90%', marginTop:'20px', marginBottom:'20px'}}
                    options={Object.keys(userTags)}
                    getOptionLabel={(option) => userTags[option].name}
                    value={tagIds}
                    onChange={(newValue) => setFilter('TagIds', newValue)}
                />
                <DateRangePicker
                    ranges={[selectionRange]}
                    startDatePlaceholder="Start Date"
                    endDatePlaceholder="End Date"
                    onChange={(updatedValue)=>{
                        setFilter('Date', updatedValue)
                    }}
                />
            </div>
            <PopupDivider/>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', flexWrap:'wrap', gap:'10px', paddingLeft: isMobile ? '12px' : '20px', paddingRight: isMobile ? '12px' : '30px', paddingTop:'5px'}}>
                <FancyButton
                    style={{marginLeft:'10px'}}
                    onClick={clear}
                >
                    Clear
                </FancyButton>
                <FancyButton
                    variant="dark"
                    style={{marginLeft:'10px'}}
                    onClick={()=>setPopupOpen(false)}
                >
                    Show {Object.keys(filteredEvents).length} Events
                </FancyButton>
            </div>
        </div>
    );


  const baseStyle = {
    width: isMobile ? '40px' : '48px',
    ...(isMobile ? { height: '40px' } : {}),
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',
  };
  const activeStyle = filterCount > 0
    ? { borderColor: 'rgba(0,0,0,0.32)', background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 45%, #e0e0e0 100%)' }
    : {};

  return (
    <ButtonWithPopup
      popupOpen={popupOpen}
      setPopupOpen={setPopupOpen}
      toggleOnClick
      buttonStyle={{ ...baseStyle, ...activeStyle }}
      buttonComponent={buttonComponent}
      popupComponent={popupComponent}
      popupStyle={isMobile ? { overflow: 'hidden' } : {marginLeft:'-245px', maxHeight: popupMaxHeight + 'px', overflow:'hidden'}}
      popupClassName={isMobile ? 'mobile-header-popup mobile-header-popup--filter' : 'desktop-filter-popup'}
    />
  );
}
